import { clsx } from 'clsx'
import { FormikContext, useFormik } from 'formik'
import { forwardRef, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'

import { FormBuilderFormFactoryItem } from './components/form-builder-form-factory-item/form-builder-form-factory-item'
import { FormItemType } from './constants/form-builder.constants'
import { createBuilderValidators } from './helpers/create-builder-validators'
import { createBuilderValues } from './helpers/create-builder-values'
import { FormBuilderConfig } from './types/form-builder.types'
import styles from '../../workspace/workspace/components/milestone-check/milestone-check.module.scss'

export type FormBuilderFormFactoryProps = {
  config: FormBuilderConfig[]
  values?: Record<string, any>
  comments?: Record<string, any>
  fieldsDisabled: boolean
}

export const FormBuilderFormFactory = forwardRef(({ config, values, comments, fieldsDisabled = false }: FormBuilderFormFactoryProps, ref) => {
  const { t } = useTranslation()

  const formik = useFormik({
    initialValues: createBuilderValues(config, values),
    validationSchema: createBuilderValidators(config),
    onSubmit: () => {},
  })

  useImperativeHandle(ref, () => ({
    submit: () => {
      return {
        errors: formik.validateForm(),
        values: formik.values,
      }
    },
    clear: () => {
      formik.resetForm()
    },
  }))

  return (
    <FormikContext.Provider value={formik as any}>
      {config.length ? (
        config.map((configItem, i) => (
          <div
            key={i}
            className={configItem.type === FormItemType.Header && i !== 0 ? 'mt-2' : ''}
          >
            <FormBuilderFormFactoryItem
              key={i}
              error={formik.errors[configItem.id] as string[]}
              formikProps={{ ...formik.getFieldProps(configItem.id) }}
              isDisabled={fieldsDisabled}
              props={configItem}
              type={configItem.type}
            />
            {comments?.[configItem.id]?.length
              ? comments[configItem.id].map((comment: string, k: number) => (
                  <div
                    key={k}
                    className={clsx(styles.commentItem)}
                  >
                    {comment}
                  </div>
                ))
              : null}
          </div>
        ))
      ) : (
        <div>{t('formBuilder.factory.placeholder')}</div>
      )}
    </FormikContext.Provider>
  )
})
